/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { AudioEventStartedEvent } from './audio-event-started-event';

/**
 *
 * @export
 * @interface AudioEventStarted
 */
export interface AudioEventStarted {
  /**
   *
   * @type {string}
   * @memberof AudioEventStarted
   */
  message: AudioEventStartedMessageEnum;
  /**
   *
   * @type {AudioEventStartedEvent}
   * @memberof AudioEventStarted
   */
  event: AudioEventStartedEvent;
}

export const AudioEventStartedMessageEnum = {
  AudioEventStarted: 'AudioEventStarted',
} as const;

export type AudioEventStartedMessageEnum =
  (typeof AudioEventStartedMessageEnum)[keyof typeof AudioEventStartedMessageEnum];
